(function(){
  angular.module('tfc.retailer.StandardReports')
      .directive('standardReportsDatePicker', standardReportsDatePicker);

  function standardReportsDatePicker(){
    return{
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, elm, attr, ngModelController){
        // Had to keep shared scope as two isolated scope are not allowed on single element
        // and this directive is sharing the isolated scope with validateInputDate directive

        attr.$observe('minDate', function (newValue) {
          $(elm).datepicker('option', 'minDate', newValue);
        });

        attr.$observe('maxDate', function (newValue) {
          $(elm).datepicker('option', 'maxDate', newValue);
        });

        $scope.$watch(function () {
          return ngModelController.$modelValue;
        }, function(newValue) {
          $(elm).datepicker("setDate", newValue);
        });
        
        // Datepicker Settings
        elm.datepicker({
          inline: attr["inline"] || false,
          autoSize: true,
          dateFormat: attr["dateformat"] || 'M d, yy',
          showOn: (attr.displayIcon) ? 'both' : null,
          buttonText: '<i class="'+ (attr["buttonText"] || 'glyphicon glyphicon-calendar') +'"></i>',
          maxDate: attr["maxDate"],
          minDate: attr["minDate"],
          onSelect: function (value) {
            $scope.$apply(function () {
              ngModelController.$setViewValue(value);
              ngModelController.$render();
            });
            elm.focus();
          }

        });

      }
    }
  }

})();